// 會員註冊 SSR
export async function registerSSR(account: string, password: string, name: string): Promise<any> {
  return await $fetch('/api/auth/register', {
    method: 'POST',
    body: { 
      account: account, 
      password: password, 
      name: name 
    }
  })
}

// 會員登入 SSR
export async function loginSSR(account: string, password: string): Promise<any> {
  return await $fetch('/api/auth/login', {
    method: 'POST',
    body: { 
      account: account, 
      password: password 
    }
  })
}

// Google 登入驗證 SSR
export async function googleAuthenticateSSR(code: string, state: string): Promise<any> {
  return await $fetch('/api/auth/google-authenticate', {
    method: 'POST',
    body: { 
      code: code, 
      state: state 
    }
  })
}

// 會員登出 SSR
export async function logoutSSR(account: string): Promise<any> {
  return await $fetch('/api/auth/logout', {
    method: 'POST',
    body: { 
      account: account 
    }
  })
}
